import { LocationSpecificOffer } from "./types";
import { Language } from "../../utils/localization/languages/types";
import { OffersFromApi } from "types/api/exclusive_offers.d";
import {
  Maybe,
  SanityBlock,
  SanityMultilingualBlockContent,
  SanityMultilingualString
} from "types/graphql-types";
import { OfferCardContentImage } from "types/api/shared.d";
import { OffersPaths } from "src/utils/useRemoteOffers";
import { isPresent } from "src/utils/checks";
import { SanityImageType } from "@silversea-ssc/ui-components-react";

function languageSpecificContent(
  content: SanityMultilingualString,
  language: Language
): string;
function languageSpecificContent(
  content: SanityMultilingualBlockContent,
  language: Language
): string | Maybe<SanityBlock>[];
function languageSpecificContent(
  content: SanityMultilingualBlockContent | SanityMultilingualString,
  language: Language
): string | Maybe<SanityBlock>[] {
  if (!content) return "";
  const localizedContent = content[language.sanityCode];
  if (localizedContent) return localizedContent;

  return "";
}

const toSanityImage = (
  image: OfferCardContentImage
): SanityImageType | undefined => {
  if (!image || !image.asset) return undefined;
  return {
    asset: { _id: image.asset._id }
  };
};

export const toLocationSpecificOffer = (
  offer: OffersFromApi,
  language: Language,
  offersPathMapping: OffersPaths
): LocationSpecificOffer => ({
  ...offer,
  _key: offer.sanityId,
  id: offer.sanityId,
  fullPath: offersPathMapping[offer.sanityId],
  cardContent: {
    ...offer.cardContent,
    image: toSanityImage(offer.cardContent?.image),
    title: languageSpecificContent(offer.cardContent?.title, language),
    description: languageSpecificContent(
      offer.cardContent?.description,
      language
    )
  },
  highlightLabel: offer.highlightLabel,
  cruiseInclusions: offer.cruiseInclusions
    ?.map((x) => ({
      _key: x.text?._key,
      highlight: x.highlight,
      text: {
        localized: x.text
          ? languageSpecificContent(x.text, language)
          : undefined
      }
    }))
    .filter(isPresent)
});

export const toLocationSpecificOffers = (
  offers: OffersFromApi[],
  language: Language,
  offersPathMapping: OffersPaths
): LocationSpecificOffer[] => {
  return offers
    .map((o) => toLocationSpecificOffer(o, language, offersPathMapping))
    .filter((offer) => !!offer.fullPath);
};

export function offersToLocationSpecificOffers(
  language: Language,
  offersPathMapping: OffersPaths
): (offers: OffersFromApi[]) => LocationSpecificOffer[] {
  return (offers) =>
    toLocationSpecificOffers(offers, language, offersPathMapping);
}
